import { Box, Button, Stack, Typography } from "@mui/material";
import React from "react";
       
import Head from "next/head";
import AppbarIndustry from "../../../../components/AppbarIndustry";
import HeroSection from "../../../../components/HeroSection";
import TitleIndustry from "../../../../components/TitleIndustry";
import HeroEnquiryFormIndustry from "../../../../components/HeroEnquiryFormIndustry";
import FooterIndustry from "../../../../components/FooterIndustry";
import { ourProducts } from "../../../../components/healthcare/data";
import StickyWhatsappIndustries from "../../../../components/StickyWhatsappIndustries";

function ManagementSystems() {
  const products = [
    
    "Clinical Decision Support Systems (CDSS)",
    

  ];
  const data = {
    image: "/industries/healthcare/clinical.jpg", // Replace with the appropriate image URL
    intro: `Enter the era of intelligent healthcare decision-making with our Clinical Decision Support Systems (CDSS). Tailored for healthcare professionals, our systems leverage advanced technologies to provide real-time, evidence-based insights for informed clinical decisions.`,
    keyFeatures: [
      {
        title: "Real-time evidence-based clinical insights",
        content: "Equip healthcare professionals with real-time, evidence-based insights to support clinical decision-making.",
      },
      {
        title: "Integration with electronic health records (EHR)",
        content: "Seamlessly integrate with electronic health records (EHR) for a comprehensive patient information view.",
      },
      {
        title: "Decision support for diagnosis and treatment",
        content: "Provide decision support tools for accurate diagnosis and personalized treatment planning.",
      },
      {
        title: "Alerts and notifications for critical conditions",
        content: "Receive real-time alerts and notifications for critical conditions, enabling prompt intervention.",
      },
      {
        title: "Customizable to various medical specialties",
        content: "Customize the system to meet the specific needs of diverse medical specialties and workflows.",
      },
    ],
    howItWorks: `Explore the sophisticated technologies that power our Clinical Decision Support Systems, providing healthcare professionals with the tools to enhance clinical decision-making and patient outcomes.`,
    
    benefits: {
      title: "The advantages of our Clinical Decision Support Systems",
      data: [
        "Informed clinical decisions for improved patient care.",
        "Real-time alerts for critical conditions.",
        "Integration with existing EHR systems.",
        "Enhanced diagnostic accuracy and treatment planning.",
        "Customizable to meet the needs of diverse medical specialties.",
      ],
    },
    industries:
      "Critical for healthcare providers, hospitals, and medical professionals seeking to enhance clinical decision-making and patient care outcomes.",
   
    technology: `Learn how our systems seamlessly integrate with various healthcare platforms, ensuring interoperability and efficient decision support.`,
    support: `Access training resources and our support system for effective implementation and optimal use of Clinical Decision Support Systems.`,
    industry: `Understand how our systems align with industry standards and regulatory requirements, ensuring compliance and ethical use of clinical decision support technology in healthcare.`,
  
  };
  
  
  const content = "Embark on a journey of innovation in healthcare with us! Whether you're involved in medical technology, telehealth, healthcare analytics, or any aspect of the healthcare industry, we offer tailored solutions. Our expertise extends to projects of various scales, ensuring our healthcare solutions align seamlessly with your vision, budget, and scope."
  return (
    <><Head>
    <title>Clinical Decision Support Systems (CDSS) | Improve Clinical Outcomes | Techbrain Networks</title>
    <meta name="description" content="Enhance clinical decision-making with Techbrain Networks Clinical Decision Support Systems (CDSS), designed to improve clinical outcomes and patient care." />
    <meta name="keywords" content="CDSS, clinical decision support systems, Techbrain Networks" />
    <meta property="og:title" content="Clinical Decision Support Systems (CDSS) | Improve Clinical Outcomes | Techbrain Networks" />
    <meta property="og:description" content="Techbrain Networks offers Clinical Decision Support Systems (CDSS) to enhance clinical decision-making, improve patient care, and clinical outcomes." />
    <meta property="og:type" content="website" />
    <meta property="og:url" content="https://www.techbrainnetworks.com/industries/healthcare/products/clinical-decision-support-systems" />
    <meta property="og:image" content="https://www.techbrainnetworks.com/logo-tbn.jpg" />
    <meta property="og:image:alt" content="Clinical Decision Support Systems" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="Clinical Decision Support Systems (CDSS) | Improve Clinical Outcomes" />
    <meta name="twitter:description" content="Techbrain Networks Clinical Decision Support Systems (CDSS) enhance decision-making in clinical settings, leading to improved patient care and outcomes." />
     <meta name="twitter:image" content="https://www.techbrainnetworks.com/logo-tbn.jpgg" />
    <link rel="canonical" href="https://www.techbrainnetworks.com/industries/healthcare/products/clinical-decision-support-systems" />
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "Clinical Decision Support Systems (CDSS)",
        "image": "https://www.techbrainnetworks.com/logo-tbn.jpg",
        "description": "Techbrain Networks Clinical Decision Support Systems (CDSS) enhance clinical decision-making, improve patient care, and clinical outcomes with advanced support tools.",
        "brand": "Techbrain Networks",
        "offers": {
            "@type": "Offer",
            "url": "https://www.techbrainnetworks.com/industries/healthcare/products/clinical-decision-support-systems",
            "priceCurrency": "USD",
            "price": "Contact for pricing"
        }
    })}} />
           <link rel="icon" href="/favicon.png" />

</Head>
<StickyWhatsappIndustries link={"https://api.whatsapp.com/send?phone=918754906714"}  color={"#5617ff"} />

 

      <AppbarIndustry title={"Healthcare"} homeLink={'/industries/healthcare'} link={'/industries/healthcare/products'} />
      <HeroSection img={"/industries/healthcare/clinical-decision-support-systems.avif"}>Clinical Decision Support Systems (CDSS)
</HeroSection>
      <Box
        sx={{
          px: [0, "1.2rem", "3.8rem", "3rem"],
          pb: [1, 1, 2, 2, 4],
          bgcolor: "#020108",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
        }}
      >
        {/* intro */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",

            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Introduction</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.intro}
          </Typography>
        </Box>
        {/* Key Features Unleashed */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", ".5rem", "1.5rem", "1.5rem", "1rem"],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Key Features Unleashed</TitleIndustry>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: ["column", "row"],
              flexWrap: "wrap",
              justifyContent: [null, "space-between", "flex-start"],
              gap: ["2rem", "1rem", "2rem", "2rem", "2rem"],
            }}
          >
            {data.keyFeatures.map((i, k) => (
              <Box
                sx={{
                  display: "flex",
                  width: ["95%", "45%", "30%"],
                  flexDirection: "column",
                  gap: ["0.5rem", "0.5rem", "0.5rem", "0.5rem", "1rem"],
                }}
              >
                <Typography
                  sx={{
                    fontSize: [
                      "1.3rem",
                      "1.2rem",
                      "1.2rem",
                      "1.4rem",
                      "1.5rem",
                    ],
                    fontWeight: "bold",
                    color: "#5617ff",
                  }}
                >
                  {i.title}
                </Typography>
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {i.content}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>
        {/* how it works */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            py: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>How It Works?</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.howItWorks}
          </Typography>
        </Box>
        {/* benefits */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            gap: ["1.5rem", "1.5rem", ".5rem"],
          }}
        >
          <Stack
            direction={"column"}
            sx={{
              width: ["100%", "48%"],
            }}
          >
            <TitleIndustry color={"#5617ff"}>Benefits</TitleIndustry>
            <Typography
              sx={{
                fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                color: "#fff",
              }}
            >
              {data.benefits.title}:
            </Typography>

            <Stack
              direction={"column"}
              sx={{
                gap: [1, 1, 2],
                mt: [3, 3, 4],
              }}
            >
              {data.benefits.data.map((i, k) => (
                <Typography
                  sx={{
                    fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
                    color: "#fff",
                  }}
                >
                  {"•  "}
                  {i}
                </Typography>
              ))}
            </Stack>
          </Stack>

          <Box
            sx={{
              width: ["100%", "50%", "45%"],
              height: ["20rem", "20rem", "20rem", "25rem", "30rem"],
              backgroundImage: `url(${data.image})`,
              backgroundposition: "center",
              backgroundSize: "cover",
              backgroundrepeat: "no-repeat",
              borderRadius: "16px",
            }}
          />
        </Stack>
        {/* Industries */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Industries</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industries}
          </Typography>
        </Box>

          

        {/* Future Developments and Innovations*/}
 
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Future Developments and Innovations</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
           Stay informed about upcoming features and innovations in biometric security and identity management technology.
          </Typography>
        </Box>

        {/* Technology Integration */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>Technology Integration</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.technology}
          </Typography>
        </Box>

        {/* User Training and Support */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}>User Training and Support</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.support}
          </Typography>
        </Box>

        {/*  Industry Standards and Compliance */}
        <Box
          sx={{
            width: "100%",
            maxWidth: "1260px",
            backgroundColor: "#020108",
            px: ["1rem"],
            pb: ["2rem", "2rem", "2rem", "3rem", "4rem"],
            display: "flex",
            flexDirection: "column",
            // gap: ["1.5rem", "1.5rem", "1.5rem", ],
          }}
        >
          <TitleIndustry color={"#5617ff"}> Industry Standards and Compliance</TitleIndustry>
          <Typography
            sx={{
              fontSize: ["1rem", "1rem", "1rem", "1rem", "1.2rem"],
              color: "#fff",
            }}
          >
            {data.industry}
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
          
            display: "flex",
            gap: "1rem",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box>
            <Typography
              sx={{
                fontSize: ["2rem", "3rem", "3rem", "4rem"],
                fontWeight: "bold",
                color: "#5617ff       ",
                textAlign: "center",
              }}
            >
              Contact
            </Typography>
          </Box>
          <Box
            sx={{
              width: ['100%'],
              display: "flex",
              justifyContent: "center",
              padding:'1rem'
            }}
          >
            <HeroEnquiryFormIndustry color={"#5617ff"} products={products} content={content}/>
          </Box>
        </Box>
      </Box>
      
      <FooterIndustry ourProducts={ourProducts} color={"#5617ff"} bg={"#020108"} />
    </>
  );
}

export default ManagementSystems
;
